export default class NotePath{
  barIndex: number;
  trackIndex: number;
  voiceIndex: number;
  beatIndex: number;
  noteIndex: number;
  constructor({barIndex, trackIndex, voiceIndex, beatIndex, noteIndex}: NotePath){
    Object.assign(this, {barIndex, trackIndex, voiceIndex, beatIndex, noteIndex});
  }
}